var Curriculog = Curriculog || {};

Curriculog.ProposalList = (function ($, _, Backbone, ProposalList) {

	ProposalList = Backbone.View.extend({
		el: function() {
			return $('#curriculog-list-column-results-content');
		},

		events: {},

		initialize: function (options) {
			this.user = options.user;
			this.params = options.params;
			this.collection = options.collection;
			this.paging = new Curriculog.Paging({}, {params: this.params, collection: this.collection});
			this.pagingView = new Curriculog.PageFilter({
				model: this.paging,
				params: this.params,
				collection: this.collection
			});

			var showAllProposals = proposals.userPermissions.permissions.showAllProposals;
			var transparency = showAllProposals && this.user.get('permissions').transparency_dashboard_view;
			this.hasAccess = ((this.user.get('id') > 0) || transparency === 1) ? true : false;

			this.itemViews = [];
			this.flyoutViews = [];
			this.initialRender();
			this.listenTo(Backbone, 'filter:submit', this.getProposals);
			this.listenTo(Backbone, 'filter:page', this.getPage);
			this.listenTo(Backbone, 'listItem:checkPage', this.setPage);
		},

		initialRender: function() {
			// this is used on the first page load, to indicate fetching of
			// the proposal collection
			if (this.hasAccess) {
				this.addLoading();
			} else {
				this.addNoAccess();
			}
		},

		render: function () {
			if (! this.hasAccess) {
				this.addNoAccess();
			} else if (!this.collection.isEmpty()) {
				_.each(this.collection.getModelSlice(), this.addProposal, this);
				this.addPaging();
			} else if (this.collection.isEmpty() && this.hasAccess) {
				this.addNoResult();
			}
			this.showListItems();
		},

		getProposals: function () {
			if (! this.hasAccess) {
				return;
			}

			this.get(this.collection.url(), false, true);
		},

		getPage: function () {
			if (! this.hasAccess) {
				return;
			}

			// if the models have already been fetched, just re-render the view
			var models = this.collection.getModelSlice();
			var exist = _.every(models, function(model){ return _.has(model.attributes, 'name'); } );
			if (! exist) {
				var idSlice = this.collection.getIdSlice();
				this.get(this.collection.url(idSlice), false, false);
			} else {
				this.hideListItems();
				this.hideFlyout();
				this.reset();
				this.render();
			}

		},

		get: function(url, remove, reset) {
			var that = this;
				level = this.params.domParams.get('level');

			this.params.deleteSession(level);
			this.params.setSession(level);

			var ids  = this.collection.getIdSlice();
			if (ids.length !== 0) {
				this.params.queryParams.set('ids', ids);
			};

			this.collection.fetch({
				url: url,
				reset: reset,
				remove: remove,
				data: this.params.paramsData(),
				method: 'POST',
				beforeSend: function () {
					$('div.qtip-active').css('display', 'none').removeClass('qtip-active');
					that.hideListItems();
					that.hideFlyout();
				},
				success: function () {
					that.reset();
					that.render();
					Curriculog.Actions.log('list-page-loaded');
				},
				error: function () {
					var errorMsg = 'There was an error with this search.' +
									' Please try your search again. ' +
									'<br><br>This problem has been reported.';
					$('#growls').notify('create', 'warning-template', {
						title: 'Warning',
						text: errorMsg
					},{
						expires: false
					});
				}
			});
		},

		addProposal: function (model) {
			// add list item
			var itemView = new Curriculog.ProposalListItem({
				model: model,
				user: this.user,
				params: this.params
			});

			// add flyout item
			var flyoutView = new Curriculog.ProposalFlyout({
				model: model,
        params: this.params
			});

			this.itemViews.push(itemView);
			this.flyoutViews.push(flyoutView);

			this.$el.append(itemView.render());
			$('#curriculog-summary-column').append(flyoutView.render());
		},

		addNoResult: function() {
			var html = nunjucks.render('ProposalList/proposalListNone.html');
			this.$el.append(html);
		},

		addNoAccess: function() {
			var html = nunjucks.render('ProposalList/proposalListNoAccess.html');
			this.$el.append(html);
		},

		addLoading: function() {
			var html = nunjucks.render('ProposalList/proposalListLoading.html');
			this.$el.append(html);
		},

		addPaging: function() {
			this.paging.update();
			this.pagingView.reset();
			this.pagingView.render();
		},

		showListItems: function() {
			// fade the list in so the user knows the list is loading
			this.$el.find('.open-summary, .no-summary').each(function (index) {
				$(this).css('visibility', 'visible').hide().fadeTo('opacity','1');
			});

			$('#curriculog-list-column-results-paging')
				.css('visibility','visible')
				.hide()
				.fadeTo(200, 1);

			setTimeout(function() {
				Backbone.trigger('list:stretch');
			}, 200);
		},

		hideListItems: function() {
			// show feedback to user so they know the list is changing
			$('#curriculog-list-column-results-paging')
				.fadeTo(200, 0.33);

			this.$el.find('.open-summary, .no-summary').reverse().each(function (index) {
				$(this).fadeTo(200, 0.33);
			});
		},

		hideFlyout: function() {
			objDom.summaryFlyout();
		},

		reset: function() {
			// empty the list
			this.$el.empty();
			$('#curriculog-summary-column').empty();

			// destroy dom nodes
			_.each(this.itemViews, function(element) {
				element.remove();
				element.stopListening();
			});
			_.each(this.flyoutViews, function(element) {
				element.remove();
				element.stopListening();
			});

			// // clear out the references
			this.itemViews = [];
			this.flyoutViews = [];

			// reset paging view
			this.pagingView.reset();
		},

		setPage: function() {
			// if user is operating on the list to change its potential result count,
			// we need to ensure the page we are currently viewing will still exist
			// when the new results return

			// event called when watching, unwatching, exporting, deleting, stuck

			// If there is only one result, remainingRecords will calculate to 1, so
			// we have to check that we are not the only record

			var limit = this.params.pagingParams.get('limit');
			var page = this.params.pagingParams.get('page');
			var totalProposals = this.paging.get('totalProposals');
			var totalPages = this.paging.get('totalPages');
			var isLastPage = (page === totalPages)? true : false;
			var isOnlyRecord = (totalProposals === 1)? true: false;
			var remainingRecords = ((totalProposals - 1) / limit);

			if (isLastPage && ! isOnlyRecord && (remainingRecords === (totalPages - 1))) {
				console.log('resetting page by one');
				this.params.pagingParams.set('page', (+page - 1));
			}

			Backbone.trigger('filter:submit');

		},

	});

	return ProposalList;

})($, _, Backbone, Curriculog.ProposalList || {});
